import OrgVideosDropList from '@/components/Library/OrgVideosDropList';
import UpgradeFreePlanModal from '@/components/Modals/UpgradeFreePlanModal';
import { DeleteLibraryItemModal } from '@/pages/home/components/DeleteLibraryItemModal';
import { Header } from '@/pages/video-studio/components';
import { VideoLibrary } from '@/pages/video-studio/components/VideoLibrary';
import styled from '@emotion/styled';
import { SortBy } from './components/SortBy';
import { TabSwitcher } from './components/TabSwitcher';

export const SectionTitle = styled.h2`
    color: ${({ theme }) => theme.colors.black[700]};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.32px;
`;

const SectionContainer = styled.div`
    margin: 32px 0 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: space-between;
    border-bottom: 1px solid ${({ theme }) => theme.colors.black[200]};
`;

const DropdownsContainer = styled.div`
    display: flex;
    gap: 2rem;
`;

export const VideoStudioPage = () => {
    return (
        <>
            <Header />
            <SectionContainer>
                <TabSwitcher />
                <DropdownsContainer>
                    <OrgVideosDropList />
                    <SortBy />
                </DropdownsContainer>
            </SectionContainer>
            <VideoLibrary />
            <DeleteLibraryItemModal />
            <UpgradeFreePlanModal from="video-studio" />
        </>
    );
};
